import { Link } from "@tanstack/react-router";
import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { SigBreadcrumb } from "../components/SigBreadcrumb";
import { SigExplainer } from "../components/SigExplainer";
import { SignatureMaker } from "../components/SignatureMaker";

export function SignatureMakerHub() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <SigBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.sig_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.sig_hub_intro()}
          </p>
        </header>

        <SignatureMaker defaultMode="draw" />

        <p className="mt-4 text-sm text-muted-foreground">
          {m.sig_hub_type_hint()}{" "}
          <Link
            to="/signature-maker/type"
            className="text-primary underline-offset-4 hover:underline"
          >
            {m.sig_nav_type()}
          </Link>
        </p>

        <SigExplainer
          howTo={m.sig_hub_howto()}
          faqs={[
            { q: m.sig_hub_faq1_q(), a: m.sig_hub_faq1_a() },
            { q: m.sig_hub_faq2_q(), a: m.sig_hub_faq2_a() },
            { q: m.sig_hub_faq3_q(), a: m.sig_hub_faq3_a() },
            { q: m.sig_hub_faq4_q(), a: m.sig_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
